import React from 'react'

function ClinicInfoText({clinicInfo}) {
  return (
   <>
    {clinicInfo && <>
    
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Name</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.name && clinicInfo.name}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Email</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.email && clinicInfo.email}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Phone</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.phone && clinicInfo.phone}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Sms</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.sms && clinicInfo.sms}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Signature</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.signature && clinicInfo.signature}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Website</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.website && clinicInfo.website}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Address (Street)</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.street && clinicInfo.street}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">City</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.city && clinicInfo.city}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Postal Code</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.postalCode && clinicInfo.postalCode}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Province</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.province && clinicInfo.province}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Country</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.country && clinicInfo.country}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Timezone</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.timezone && clinicInfo.timezone}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Email Verified</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.isEmailVerified && clinicInfo.isEmailVerified}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Sms Verified</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.isSmsVerified && clinicInfo.isSmsVerified}</span>
        </div>
    </div>
    <div className="row mb-5">
        <label htmlFor="" className="col-lg-4 fw-semibold text-muted">Phone Verified</label>
        <div className="col-lg-8">
            <span className="fw-bold fs-6 text-gray-800">{clinicInfo.isPhoneVerified && clinicInfo.isPhoneVerified}</span>
        </div>
    </div>
    </>}
   </>
  )
}

export default ClinicInfoText